<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Dog Walker Applications'
                    : 'Deleted Walker Applications'
                "
              ></h3>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="(filter.is_active = null), (page = 1)"
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left" style="min-width: 130px">
                        Status
                      </th>
                      <th class="text-left" style="min-width: none">
                        Full Name
                      </th>
                      <th class="text-left" style="min-width: none">Age</th>
                      <th class="text-left" style="min-width: none">
                        Phone No
                      </th>
                      <th class="text-left" style="min-width: none">
                        Whatsapp No
                      </th>
                      <th class="text-left" style="min-width: none">Area</th>
                      <th class="text-left" style="min-width: none">Pincode</th>
                      <th class="text-left" style="min-width: none">
                        Preferred Timeslot
                      </th>
                      <th class="text-left" style="min-width: none">
                        Is Experienced
                      </th>
                      <th class="text-left" style="min-width: none">
                        Has Internet Access
                      </th>
                      <th class="text-left" style="min-width: 160px">
                        Created At
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="pet_walkie_career_requests.length != 0">
                    <tr
                      v-for="(
                        pet_walkie_career_request, i
                      ) in pet_walkie_career_requests"
                      :key="`pet_walkie_career_request_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last':
                          pet_walkie_career_requests.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="pet_walkie_career_request.status == 1"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Approved
                            </v-chip>
                          </template>
                          <span>Request has been approved</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-else-if="pet_walkie_career_request.status == 2"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Rejected
                            </v-chip>
                          </template>
                          <span>Request has been rejected</span>
                        </v-tooltip>
                        <v-tooltip bottom v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="yellow"
                              text-color="black"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-clock-outline</v-icon>
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>Waiting for Approval</span>
                        </v-tooltip>
                      </td>
                      <td>{{ pet_walkie_career_request.user_name || "" }}</td>
                      <td>{{ pet_walkie_career_request.age || "" }}</td>
                      <td>{{ pet_walkie_career_request.phone_no || "" }}</td>
                      <td>{{ pet_walkie_career_request.whatsapp_no || "" }}</td>
                      <td>{{ pet_walkie_career_request.area || "" }}</td>
                      <td>{{ pet_walkie_career_request.pin_code || "" }}</td>
                      <td>
                        {{ pet_walkie_career_request.preferred_timeslot || "" }}
                      </td>
                      <td>
                        {{ pet_walkie_career_request.is_experienced || "" }}
                      </td>
                      <td>
                        {{
                          pet_walkie_career_request.has_internet_access || ""
                        }}
                      </td>
                      <td style="min-width: 160px">
                        {{ formatDate(pet_walkie_career_request.created_at) }}
                      </td>
                      <td class="text-right">
                        <v-btn v-can:edit="'dog_walker_requests'"
                          v-if="pet_walkie_career_request.status === 0"
                          class="ml-2"
                          x-small
                          fab
                          color="success"
                          @click="updateStatus(pet_walkie_career_request.id, 1)"
                        >
                          <v-icon dark>mdi-check</v-icon>
                        </v-btn>

                        <!-- Reject button (only show if status is 0) -->
                        <v-btn v-can:edit="'dog_walker_requests'"
                          v-if="pet_walkie_career_request.status === 0"
                          class="ml-2"
                          x-small
                          fab
                          color="error"
                          @click="updateStatus(pet_walkie_career_request.id, 2)"
                        >
                          <v-icon dark>mdi-close</v-icon>
                        </v-btn>
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'dog_walker_requests'"
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="error"
                                @click="
                                  OpenWarning(pet_walkie_career_request.id)
                                "
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this PetWalkieCareerRequest</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/pet-walkie-career-requests/${encryptIt(
                                  pet_walkie_career_request.id,
                                )}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this PetWalkieCareerRequest</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'dog_walker_requests'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="
                                  Restore_this(pet_walkie_career_request.id)
                                "
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this pet_walkie_career_request</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="100" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_pet_walkie_career_request" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>PetWalkieCareerRequest deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_pet_walkie_career_request = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_restored_pet_walkie_career_request" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>PetWalkieCareerRequest restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_pet_walkie_career_request = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Delete Warning Dialog Box -->
      <v-dialog v-model="deleteDialog" width="550px">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 150px"
                >
                  mdi-delete-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>Are you sure you want to delete this?</h3>
                      <br />
                      <v-btn color="grey" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="red"
                        dark
                        class="ml-5"
                        @click="
                          Delete_this(to_be_deleted_id), (deleteDialog = false)
                        "
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "PetWalkieCareerRequestsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        show_deleted: false,
      },
      pet_walkie_career_requests: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportPetWalkieCareerRequestTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      delete_pet_walkie_career_request: false,
      is_deleted_pet_walkie_career_request: false,
      restore_pet_walkie_career_request: false,
      is_restored_pet_walkie_career_request: false,
      deleteDialog: false,
      to_be_deleted_id: "",
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    OpenWarning(request_id) {
      this.to_be_deleted_id = request_id;
      this.deleteDialog = true;
    },
    updateStatus(id, newStatus) {
      this.pendingRequestId = id;
      this.pendingStatus = newStatus;

      if (newStatus === 2) {
        // If rejecting, show reason dialog
        this.propertyToReject = this.properties.find((p) => p.id === id);
        this.rejectionReason = "";
        this.rejectionDialog = true;
      } else {
        const actionMap = {
          1: "approve",
          2: "reject",
          3: "deactivate",
        };
        this.confirmMessage = `Are you sure you want to ${actionMap[newStatus]} this request?`;
        this.pendingAction = "updateStatus";
        this.confirmDialog = true;
      }
    },
    async getData() {
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`pet_walkie_career_requests?${query}`)
        .then((response) => {
          this.pet_walkie_career_requests = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(
        `pet_walkie_career_request_exports?${query}`,
      );
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_pet_walkie_career_request = true;
      await axios
        .post(`/pet_walkie_career_requests/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_pet_walkie_career_request = false;
          this.is_deleted_pet_walkie_career_request = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
    async Restore_this(id) {
      this.restore_pet_walkie_career_request = true;
      await axios
        .post(`/pet_walkie_career_requests/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_pet_walkie_career_request = false;
          this.is_restored_pet_walkie_career_request = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
  },
};
</script>
